export default __webpack_public_path__ + "static/media/ChaletComprime-HongKongSixt.7e05aa7d.otf";